import Subtitle from "../../../atoms/typography/Subtitle";
import { LoanOptionButton } from "../../../atoms/buttons/LoanOptionButton";
import React from "react";

export const LoanOptionBlockMobile = ({ data, customFormEdit }) => {
  return (
    <div className="loan-options-row-wrapper loan-option-block-mobile-wrapper">
      <div>
        <div className="loan-options-top-wrapper">
          <div className="loan-option-type-wrapper">
            <div className="loan-option-type-icon">
              <img src="/img/svg_icons/fixed_bold.svg" />
            </div>
            <div className="loan-option-type-subtitle">
              <Subtitle>Fixed</Subtitle>
            </div>
          </div>
          <div className="loan-options-fixed-wrapper">
            <LoanOptionButton
              title="10"
              subtitle="year"
              selected={
                data.loanOptions && data.loanOptions?.includes("10Fixed")
              }
              onClick={() => {
                let newLoanOptions = [];
                if (Array.isArray(data.loanOptions)) {
                  newLoanOptions = [...data.loanOptions];
                }
                if (data.loanOptions && data.loanOptions?.includes("10Fixed")) {
                  newLoanOptions = newLoanOptions.filter(
                    (item) => item !== "10Fixed"
                  );
                } else {
                  newLoanOptions.push("10Fixed");
                }
                customFormEdit("loanOptions", newLoanOptions);
              }}
            />
            <LoanOptionButton
              title="15"
              subtitle="year"
              selected={
                data.loanOptions && data.loanOptions?.includes("15Fixed")
              }
              onClick={() => {
                let newLoanOptions = [];
                if (Array.isArray(data.loanOptions)) {
                  newLoanOptions = [...data.loanOptions];
                }
                if (data.loanOptions && data.loanOptions?.includes("15Fixed")) {
                  newLoanOptions = newLoanOptions.filter(
                    (item) => item !== "15Fixed"
                  );
                } else {
                  newLoanOptions.push("15Fixed");
                }
                customFormEdit("loanOptions", newLoanOptions);
              }}
            />
            <LoanOptionButton
              title="20"
              subtitle="year"
              selected={
                data.loanOptions && data.loanOptions?.includes("20Fixed")
              }
              onClick={() => {
                let newLoanOptions = [];
                if (Array.isArray(data.loanOptions)) {
                  newLoanOptions = [...data.loanOptions];
                }
                if (data.loanOptions && data.loanOptions?.includes("20Fixed")) {
                  newLoanOptions = newLoanOptions.filter(
                    (item) => item !== "20Fixed"
                  );
                } else {
                  newLoanOptions.push("20Fixed");
                }
                customFormEdit("loanOptions", newLoanOptions);
              }}
            />
            <LoanOptionButton
              title="30"
              subtitle="year"
              selected={
                data.loanOptions && data.loanOptions?.includes("30Fixed")
              }
              onClick={() => {
                let newLoanOptions = [];
                if (Array.isArray(data.loanOptions)) {
                  newLoanOptions = [...data.loanOptions];
                }
                if (data.loanOptions && data.loanOptions?.includes("30Fixed")) {
                  newLoanOptions = newLoanOptions.filter(
                    (item) => item !== "30Fixed"
                  );
                } else {
                  newLoanOptions.push("30Fixed");
                }
                customFormEdit("loanOptions", newLoanOptions);
              }}
            />
          </div>
        </div>

        <div className="loan-options-bottom-wrapper">
          <div className="loan-option-type-wrapper">
            <div className="loan-option-type-icon">
              <img src="/img/svg_icons/arm_bold.svg" />
            </div>
            <div className="loan-option-type-subtitle">
              <Subtitle>ARM</Subtitle>
            </div>
          </div>
          <div className="loan-options-arm-wrapper">
            <LoanOptionButton
              title="5/6"
              subtitle="ARM"
              selected={data.loanOptions && data.loanOptions?.includes("ARM56")}
              onClick={() => {
                let newLoanOptions = [];
                if (Array.isArray(data.loanOptions)) {
                  newLoanOptions = [...data.loanOptions];
                }
                if (data.loanOptions && data.loanOptions?.includes("ARM56")) {
                  newLoanOptions = newLoanOptions.filter(
                    (item) => item !== "ARM56"
                  );
                } else {
                  newLoanOptions.push("ARM56");
                }
                customFormEdit("loanOptions", newLoanOptions);
              }}
            />
            <LoanOptionButton
              title="7/6"
              subtitle="ARM"
              selected={data.loanOptions && data.loanOptions?.includes("ARM76")}
              onClick={() => {
                let newLoanOptions = [];
                if (Array.isArray(data.loanOptions)) {
                  newLoanOptions = [...data.loanOptions];
                }
                if (data.loanOptions && data.loanOptions?.includes("ARM76")) {
                  newLoanOptions = newLoanOptions.filter(
                    (item) => item !== "ARM76"
                  );
                } else {
                  newLoanOptions.push("ARM76");
                }
                customFormEdit("loanOptions", newLoanOptions);
              }}
            />
            <LoanOptionButton
              title="10/6"
              subtitle="ARM"
              selected={
                data.loanOptions && data.loanOptions?.includes("ARM106")
              }
              onClick={() => {
                let newLoanOptions = [];
                if (Array.isArray(data.loanOptions)) {
                  newLoanOptions = [...data.loanOptions];
                }
                if (data.loanOptions && data.loanOptions?.includes("ARM106")) {
                  newLoanOptions = newLoanOptions.filter(
                    (item) => item !== "ARM106"
                  );
                } else {
                  newLoanOptions.push("ARM106");
                }
                customFormEdit("loanOptions", newLoanOptions);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
